module.exports = __webpack_public_path__ + "img/5.0ac4c225.png";